import { gql } from '@apollo/client';

import { AuthTokensFragment } from '@modules/auth/graphql';

export const EnableCurrentUserTFAMutation = gql`
    mutation enableCurrentUserTFA($secret: String!, $totpCode: String!) {
        enableCurrentUserTFA(secret: $secret, totpCode: $totpCode) {
            tokens {
                ...AuthTokens
            }
        }
    }
    ${AuthTokensFragment}
`;
